import { OrderProductMulticines } from "@multicines/types";
import { CONSTANTS } from "@multicines/utils";
import { AdditionalInfo, CartProduct } from "artisn/types";

const { DISCAPACIDAD, TERCERA_EDAD, DISCAPACIDAD_TERCERA_EDAD } = CONSTANTS;

export const getIsSpecialPerson = (person?: string): boolean => {
  if (!person) return false;

  return (
    person === DISCAPACIDAD ||
    person === TERCERA_EDAD ||
    person === DISCAPACIDAD_TERCERA_EDAD
  );
};

export const findSpecialPerson = (
  tickets: CartProduct<AdditionalInfo, AdditionalInfo>[]
): boolean => {
  if (!tickets) return false;

  const firstSpecialPerson = tickets.find(ticket => {
    const { additionalInfo } = ticket;
    const { special_person_type } = additionalInfo ?? {};
    const { specialPersonType } = additionalInfo ?? {};
    return getIsSpecialPerson(specialPersonType ?? special_person_type);
  });
  return !!firstSpecialPerson;
};

export const leastOneIsCorporativeTicket = (
  tickets?: OrderProductMulticines[]
): boolean => {
  if (!tickets) return false;

  const firstCorporateTicket = tickets.find(ticket => {
    const { additionalInfo } = ticket;
    const { is_redeemable } = additionalInfo ?? {};
    return is_redeemable;
  });

  return !!firstCorporateTicket;
};
